import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import SchoolList from '@bd/bdui-schoollist';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import AccordionToggle from '../../components/AccordionToggle';
// import { colors } from '../../styles';

const styles = css`
`;

function Specifications({ community }) {
  return (
    <div className={styles}>
      <div className="DetailSection">
        <div className="ScrollTarget" id="schools" />
        <AccordionToggle
          openOnId="schools"
          button={({ contentVisible }) => (
            <div className="container DetailSection_headingWrapper">
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Schools</h3>
            </div>
          )}
          noToggleDesktop
        >
          <div className="container">
            <SchoolList schools={get(community, 'schools', [])} />
          </div>
          {/* <ul className="container DetailSection_table">
            {
              get(community, 'schools', []).length &&
              get(community, 'schools').map(school => (
                <li className="row" key={school.name}>
                  <div className="col-4 pr-0">
                    <div className="DetailSection_tableLabel">
                      {school.type}
                    </div>
                  </div>
                  <div className="col-8 pl-0">
                    <div className="DetailSection_tableContent">
                      {school.name}
                    </div>
                  </div>
                </li>
              ))
            }
          </ul> */}
        </AccordionToggle>
      </div>
    </div>
  );
}

Specifications.propTypes = {
  community: PropTypes.object.isRequired,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
  },
)(Specifications);



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/Schools.js